/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 31/07/13
 * Time: 10:25
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCard_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/loyaltyCards/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get:   { method: 'GET' },
                getSms:   { method: 'GET', isArray: true, url: baseUrl + 'rest/loyaltyCards/getSms/:id'},
                getDeleted: { method: 'GET', isArray: true , url:baseUrl+'rest/loyaltyCards/deleted'},
                editable: { method: 'GET', isArray: false , url: baseUrl + 'rest/loyaltyCards/:id/editable'}
            }
        );
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCard',["LoyaltyCard_Resource","ImageData","LoyaltyCardData","SupplierData","LoyaltyCardCategoryData","CompanyImageData","HrRootCategory",
        function (LoyaltyCard_Resource,ImageData,LoyaltyCardData,SupplierData,LoyaltyCardCategoryData,CompanyImageData,HrRootCategory)
    {

        var LoyaltyCard = function (resource,parentCategory)
        {
            this.id = null;
            this.isDeleted;
            this.label = "";
            this.style = "";
            this.type = null;
            this.itemType = null;
            this.monthValidity= null;
            this.alertExp=0;
            this.description= "";
            this.price= null;
            this.image = null;
            this.companyImage = null;
            this.specificImage = null;
            this.isVisibleOnWebSite = true;//Default;
            this.isBuyableOnWebSite = false;//Default;
            this.goalPts = null;
            this.goalType = null;
            this.goalAmount = null;
            this.goalText = null;
            this.version = null;
            if (resource !== undefined && resource != null)
            {
                this.loadObject(resource);
            }

            if (parentCategory !== undefined && parentCategory != null)
            {
                this.parentCategory = parentCategory;
            }

            LoyaltyCardData.add(this);
        }
        LoyaltyCard.prototype.loadObject = function(object,parentCategory)
        {
            //Assume here than the object in parameter contains only id (must load them)
            if (!this.id)
                this.id = object.id;
            this.isDeleted = object.isDeleted;
            this.parentCategoryId =  object.parentCategoryId;
            this.label = object.label;
            this.style = object.style;
            this.type = object.type;
            this.itemType = object.itemType;
            this.monthValidity = object.monthValidity;
            this.alertExp = object.alertExp;
            this.description= object.description;
            this.price= object.price;
            this.imageId =  object.imageId;
            this.companyImageId =  object.companyImageId;
            this.specificImage = object.specificImage;
            this.isVisibleOnWebSite = object.isVisibleOnWebSite;
            this.isBuyableOnWebSite = object.isBuyableOnWebSite;
            this.goalPts = object.goalPts;
            this.goalType = object.goalType;
            this.goalAmount = object.goalAmount;
            this.goalText = object.goalText;
            if (object.version)
                this.version = object.version;
            if (parentCategory!==undefined && parentCategory!=null)
            {
                this.parentCategory=  parentCategory;
            }
        }
        LoyaltyCard.prototype.getObjectResource = function()
        {
            var rsLoyaltyCard = new LoyaltyCard_Resource();
            rsLoyaltyCard.id = this.id;
            rsLoyaltyCard.isDeleted = this.isDeleted;
            rsLoyaltyCard.style =this.style;
            rsLoyaltyCard.label =this.label;
            rsLoyaltyCard.type =this.type;
            rsLoyaltyCard.itemType =this.itemType;
            rsLoyaltyCard.monthValidity =this.monthValidity;
            rsLoyaltyCard.alertExp =this.alertExp;
            if (this.image)
                rsLoyaltyCard.imageId = this.image.id;
            if (this.companyImage)
                rsLoyaltyCard.companyImageId = this.companyImage.id;
            rsLoyaltyCard.specificImage = this.specificImage;
            rsLoyaltyCard.description = this.description ;
            rsLoyaltyCard.price= this.price;
            rsLoyaltyCard.isVisibleOnWebSite = this.isVisibleOnWebSite;
            rsLoyaltyCard.isBuyableOnWebSite = this.isBuyableOnWebSite;
            rsLoyaltyCard.goalPts = this.goalPts;
            rsLoyaltyCard.goalType = this.goalType;
            rsLoyaltyCard.goalAmount = this.goalAmount;
            rsLoyaltyCard.goalText = this.goalText;
            if (this.parentCategory!=null)
                rsLoyaltyCard.parentCategoryId = this.parentCategory.getId();

            return rsLoyaltyCard;
        }

        LoyaltyCard.prototype.loadRef =  function()
        {
            if (this.imageId)
                this.image = ImageData.getById(this.imageId);
            if (this.companyImageId)
                this.companyImage = CompanyImageData.getById(this.companyImageId);
            if (this.parentCategory==null && this.parentCategoryId)
                this.parentCategory = LoyaltyCardCategoryData.getById(this.parentCategoryId);
        }
        LoyaltyCard.prototype.getId = function()
        {
            return this.id;
        }
        LoyaltyCard.prototype.setId = function(id)
        {
            this.id = id;
        }
        LoyaltyCard.prototype.getLabel = function()
        {
            return this.label;
        }
        LoyaltyCard.prototype.reload = function(endFunction)
        {
            var loyaltyCardSrv = this.getObjectResource();
            var loyaltyCard = this;
            if (this.getId()!=null)
                loyaltyCardSrv.$get({id:this.getId()}, //params
                    function (data) {   //success
                        loyaltyCard.loadObject(data);
                        if (endFunction !=undefined)
                            endFunction(loyaltyCard);
                    },
                    function (data) {   //failure
                        //error handling goes here
                        //TODO
                    });
        }

        LoyaltyCard.prototype.isDescendantOf = function(category) {
            var isDescendantOf = false;
            if(this.parentCategory === category) {
                isDescendantOf = true;
            }
            else {
                if(this.parentCategory) {
                    isDescendantOf = this.parentCategory.isDescendantOf(category);
                }
            }

            return isDescendantOf;
        }

        return LoyaltyCard;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardSrv',["$log","HumanResourceData","HumanResourceSrv","LoyaltyCard_Resource","LoyaltyCard","LoyaltyCardCategoryData","UserActionData","LoyaltyCardData","ServerSrv",
        function ($log,HumanResourceData,HumanResourceSrv,LoyaltyCard_Resource,LoyaltyCard,LoyaltyCardCategoryData,UserActionData,LoyaltyCardData,ServerSrv)
    {
        var  loyaltyCardSrv =
        {};
        loyaltyCardSrv.save =  function(loyaltyCard,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(loyaltyCardSrv.saveSync, loyaltyCard, successFunction, errorFunction);
        };
        loyaltyCardSrv.saveSync = function(loyaltyCard,successFunction,errorFunction)
        {
            //$timeout (function () {

            var LoyaltyCardRes = loyaltyCard.getObjectResource();
            LoyaltyCardRes.$save({}, //no params
                function (loyaltyCardRes) {
                    try{
                        if(loyaltyCard.id == null) {
                            loyaltyCard.id= loyaltyCardRes.id;
                        }
                        if (!loyaltyCard.version || (loyaltyCardRes.version && loyaltyCardRes.version > loyaltyCard.version))
                            loyaltyCard.version = loyaltyCardRes.version;

                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        loyaltyCardSrv.remove =  function(loyaltyCard,successFunction,errorFunction)
        {
            LoyaltyCardData.remove(loyaltyCard);
            ServerSrv.startSavingProcess(loyaltyCardSrv.removeSync, loyaltyCard, successFunction, errorFunction);
        };
        loyaltyCardSrv.removeSync =  function(loyaltyCard,successFunction,errorFunction)
        {
            var loyaltyCardRes = new LoyaltyCard_Resource();
            loyaltyCardRes.$remove({id:loyaltyCard.getId()}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        }
        loyaltyCardSrv.restore =  function(loyaltyCard,successFunction,errorFunction)
        {
            LoyaltyCardData.restore(loyaltyCard);
            ServerSrv.startSavingProcess(loyaltyCardSrv.restoreSync, loyaltyCard, successFunction, errorFunction);
        };
        loyaltyCardSrv.restoreSync =  function(loyaltyCard,successFunction,errorFunction)
        {
            var loyaltyCardRes = loyaltyCard.getObjectResource();
            loyaltyCardRes.$save({}, //params : id
                function (data) {
                    try{
                        //TODO UserActionData.add(data.userAction);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        }
        loyaltyCardSrv.query = function(successFunction,errorFunction)
        {
            LoyaltyCard_Resource.getDeleted(
                {}, //params
                function (data) {   //success

                    LoyaltyCardData.deletedLoyaltyCards = [] ;
                    for (var i=0;i< data.length;i++)
                        new LoyaltyCard(data[i]);//Auto Add to LoyaltyCardData

                    if (successFunction!== undefined )
                        successFunction(LoyaltyCardData.categoryRoot);
                },
                function (data) {   //failure
                    $log.error("LoyaltyCard_Resource.getDeleted error");
                    $log.error(data);
                    if (errorFunction!== undefined)
                        errorFunction(data);

                });
        };
        loyaltyCardSrv.getSms = function(smsCampaign,successFunction,errorFunction)
        {
            if (smsCampaign)
            {
                LoyaltyCard_Resource.getSms(
                    {id:smsCampaign.id}, //params
                    function (data) {
                        if (successFunction!== undefined)
                            successFunction(data);
                    },
                    function (data) {
                        if (errorFunction!== undefined)
                            errorFunction(data);
                    });
            }
            else
            if (errorFunction!== undefined)
                errorFunction();
        }
        loyaltyCardSrv.loadRef =  function()
        {
            var loyaltyCards = LoyaltyCardData.indexLoyaltyCards;
            for (var i=0;i<loyaltyCards.length;i++)
                loyaltyCards[i].loadRef();

        }
        loyaltyCardSrv.updateLocally =  function(id,object)
        {
            var loyaltyCard =  null;
            var category = LoyaltyCardCategoryData.getById(object.parentCategoryId);
            if (category!=null)
                loyaltyCard = category.getLoyaltyCardById(id)
            if (loyaltyCard!=null)
            {
                loyaltyCard.loadObject(object,category);
            }
            return loyaltyCard
        }
        loyaltyCardSrv.addLocally =  function(id,object)
        {
            var loyaltyCard =  null;
            var category = LoyaltyCardCategoryData.getById(object.parentCategoryId);
            if (category!=null)
            {
                loyaltyCard  = new LoyaltyCard(object,category);
                loyaltyCard.id = id;
                category.addLoyaltyCard();

            }
            return null;

        }
        loyaltyCardSrv.removeLocally =  function(id,object)
        {
            var loyaltyCard =  null;
            var category = LoyaltyCardCategoryData.getById(object.parentCategoryId);
            if (category!=null)
                loyaltyCard = category.getLoyaltyCardById(id)
            if (loyaltyCard!=null)
                category.removeLoyaltyCard(loyaltyCard);
            return loyaltyCard;
        }

        loyaltyCardSrv.editable = function (loyaltyCardId) {
            return LoyaltyCard_Resource.editable({id: loyaltyCardId}).$promise;
        }

        return loyaltyCardSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardData',["$log", function ($log)
    {
        var  loyaltyCardData =
        {
            indexLoyaltyCards : [], //Used as Index
            deletedLoyaltyCards : []
        };
        loyaltyCardData.getById =  function(loyaltyCardId)
        {
            for (var i=0;i<this.indexLoyaltyCards.length;i++)
                if (this.indexLoyaltyCards[i].id==loyaltyCardId)
                    return this.indexLoyaltyCards[i];
            return null;
        }
        loyaltyCardData.getByIndex =  function(servIndex)
        {
            if (servIndex>=0 && servIndex<this.indexLoyaltyCards.length)
            {
                return this.indexLoyaltyCards[servIndex];
            }
            else
                return null;
        }
        loyaltyCardData.getIndexOf =  function(loyaltyCard)
        {
            if (loyaltyCard)
                return this.indexLoyaltyCards.indexOf(loyaltyCard);
            return -1;
        }
        loyaltyCardData.add =  function(loyaltyCard)
        {
            this.indexLoyaltyCards.push(loyaltyCard);
            if (loyaltyCard.isDeleted)
            {
                var index = this.deletedLoyaltyCards.indexOf(loyaltyCard)
                if (index==-1)
                    this.deletedLoyaltyCards.push(loyaltyCard);
            }
            return this.indexLoyaltyCards.length-1;
        }
        loyaltyCardData.remove =  function(loyaltyCard) //Soft Remove
        {
            var index =  this.deletedLoyaltyCards.indexOf(loyaltyCard);
            if (index==-1)
            {
                this.deletedLoyaltyCards.push(loyaltyCard)
                loyaltyCard.isDeleted=true;
            }

        }
        loyaltyCardData.restore =  function(loyaltyCard) //Soft Remove
        {
            var index =  this.deletedLoyaltyCards.indexOf(loyaltyCard);
            if (index!=-1)
            {
                this.deletedLoyaltyCards.splice(index,1)
                loyaltyCard.isDeleted=false;
            }

        }
        loyaltyCardData.clear =  function()
        {
            loyaltyCardData.indexLoyaltyCards = [];
            loyaltyCardData.deletedLoyaltyCards = [];
        }
        loyaltyCardData.getDeletedList =  function()
        {
            return loyaltyCardData.deletedLoyaltyCards;
        }

        return loyaltyCardData;
    }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/LoyaltyCard.js